export interface IOlaylar extends IOlayTurleri {
    olayID: number;
    olayTarihi: Date;
    lokasyon: string;
    bolum: string;
    kaydedenPersonel: string;
    aciklama: string;
}

export interface IOlayTurleri {
    olayTurID: number;
    olayTuru: string;
}

export class OlaylarFilter {
    tarih: string;
    durumID: number;
}